import React from 'react';
import '../../css/header.css';
import Header from '../components/Header';

class SiteHeader extends React.Component {

    render() {
        return (
            <>
                <Header />


            </>
        )
    }
}

export default SiteHeader;